/** ABA routing number checksum (US). */
export function isValidAbaRoutingNumber(routing: string): boolean {
    if (!/^\d{9}$/.test(routing)) return false;
    const d = routing.split('').map(Number);
    const checksum = 3 * (d[0] + d[3] + d[6]) + 7 * (d[1] + d[4] + d[7]) + (d[2] + d[5] + d[8]);
    return checksum % 10 === 0;
}

function parseBankName(data: unknown): string | null {
    if (!data || typeof data !== 'object') return null;
    const obj = data as Record<string, unknown>;
    const nested = obj.data && typeof obj.data === 'object' ? (obj.data as Record<string, unknown>) : null;
    const candidates = [obj.bank_name, obj.customer_name, nested?.bank_name, nested?.customer_name];
    for (const c of candidates) {
        if (typeof c === 'string' && c.trim()) return c.trim();
    }
    return null;
}

/**
 * Look up US bank name from ABA routing number.
 * routingnumbers.info is dead (domain parked → sedo); use bankrouting.io + ibantools fallback.
 */
export async function fetchBankNameFromRouting(routing: string): Promise<string | null> {
    if (!isValidAbaRoutingNumber(routing)) return null;

    try {
        const res = await fetch(`https://bankrouting.io/api/v1/aba/${encodeURIComponent(routing)}`, {
            headers: { Accept: 'application/json' },
        });
        if (res.ok) {
            const data = await res.json();
            const name = parseBankName(data);
            if (name) return name;
        }
    } catch {
        /* try fallback */
    }

    try {
        const res = await fetch(`https://ibantools.org/api/v1/routing/ABA/${encodeURIComponent(routing)}`, {
            headers: { Accept: 'application/json' },
        });
        if (res.ok) {
            const data = await res.json();
            const name = parseBankName(data);
            if (name) return name;
        }
    } catch {
        return null;
    }

    return null;
}
